import React from 'react'
import styled, { css } from 'styled-components'
import ButtonShell from 'components/elements/Buttons/ButtonShell'

type Sizes = 's' | 'm'

export const ButtonTertiaryCSS = css<{ size: Sizes }>`
  background-color: transparent;
  display: inline-block;
  border-radius: 25px;
  overflow: hidden;
  position: relative;
  z-index: 0;
  border: 1px solid ${({ theme }) => theme.color.text};

  @media (min-width: 992px) {
    min-width: ${(props) => (props.size === 's' ? 190 : 240)}px;
  }

  @media (max-width: 991px) {
    min-width: ${(props) => (props.size === 's' ? 150 : 200)}px;
  }

  &:active {
    transform: translateY(3px);
  }

  &:not([disabled]):hover {
    cursor: pointer;

    & > a,
    & > button {
      color: red;
    }

    &:before {
      opacity: 0;
    }

    &:after {
      opacity: 1;
      transform-origin: 200px 200px;
      transform: scale(1) translate(-10px, -100px);
    }
  }

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transition: opacity 0.3s, border 0.3s;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 300px;
    height: 300px;
    background-color: ${({ theme }) => theme.color.backgroundAlt};
    border-color: transparent;
    border-radius: 50%;
    transform: translate(-10px, -70px) scale(0.1);
    opacity: 0;
    z-index: -1;
    transition: transform 0.3s, opacity 0.3s, background-color 0.3s;
  }

  & > a,
  & > button {
    color: ${(props) => props.theme.color.text} !important;
    font-weight: ${({ theme }) => theme.font.weight.regular};
    text-align: center;
    width: 100%;
    height: 100%;
    display: block;
    text-decoration: none !important;
    text-transform: uppercase;
    position: relative;
    z-index: 1;

    @media (min-width: 992px) {
      padding: ${(props) => (props.size === 's' ? '4px 25px' : '6px 35px')};
      font-size: ${({ theme }) => theme.font.size.medium};
    }

    @media (max-width: 991px) {
      padding: ${(props) => (props.size === 's' ? '4px 15px' : '6px 15px')};
      font-size: ${({ theme }) => theme.font.size.small};
    }
  }
`

const StyledButton = styled.span`
  ${ButtonTertiaryCSS};
`

interface ButtonTertiaryProps {
  isAnchor?: boolean
  isCustom?: boolean
  to: string
  className?: string
  target?: string
  size?: Sizes
}

const ButtonTertiary: React.FC<ButtonTertiaryProps> = ({
  isAnchor = false,
  isCustom = false,
  to,
  children,
  className = '',
  target = '',
  size = 'm',
}) => (
  <StyledButton className={className} size={size}>
    {isCustom ? (
      children
    ) : (
      <ButtonShell to={to} isAnchor={isAnchor} target={target}>
        {children}
      </ButtonShell>
    )}
  </StyledButton>
)

export default ButtonTertiary
